
























































import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/mixins/table.mixin';
import OrderDocumentsModal from './order-documents.modal.vue';
import { i18n } from '@/i18n';

@Component({
  components: {
    Modal: OrderDocumentsModal,
  },
})
export default class OrderDocumentsShell extends Mixins(TableMixin) {
  columns = [
    { label: '#', name: 'orderNumber', sortable: true, align: 'center' },
    {
      label: 'GENERAL.TYPE',
      name: 'type',
      sortable: true,
      field: (row: any) => row.type && i18n.t('GENERAL.' + row.type),
    },
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];

  get query() {
    return {
      params: { orderId: this.$route.params.id },
      populate: {
        path: 'order',
        select: ['type'],
      },
      filter: {
        isDeprecated: { $ne: true },
        type: {
          $in: [
            'PROPERTY_VOUCHER',
            'PROPERTY_SALES_AGREEMENT',
            'PROPERTY_CONFIRMATION_FORM',
            'RECEIPT',
            'ORDER_CANCELLATION',
          ],
        },
      },
      // lang: this.currentLang,
    };
  }
  /*
  @Watch('$i18n.locale')
  refreshResults(value: any) {
    this.currentLang = value;
  }
  */
}
